<script setup lang="ts">
import { userModule } from '@/store/user/module'
import { computed } from 'vue'
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
    EmptyState,
} = UIKit

const { errorMessage, errorDescription } = defineProps<{
    errorMessage: string
    errorDescription: string
    errorCode: string
}>()

const emit = defineEmits<{
    'close': []
}>()

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const closeAssignment = () => {
    emit('close')
}
</script>

<template>
    <div class="assignment-error">
        <EmptyState
            class="assignment-error__empty-state"
            state="assignment"
            :title="errorMessage"
            :message="errorDescription"
            :is-dark-mode="isDarkMode"
            backgroundColor="white"
        />
        <PocketButton
            class="assignment-error__close"
            @click="closeAssignment"
            :is-dark-mode="isDarkMode"
        >
            Close
        </PocketButton>
    </div>
</template>

<style lang="scss" scoped>
.assignment-error {
    padding: 56px 0 0;
    margin: 0 auto;
    text-align: center;
    width: 300px;

    &__empty-state {
        padding: 0;
    }

    &__close {
        margin: 24px auto 0;
    }

    &__icon {
        color: $caramel;
    }
}
</style>